import { TableWrapper } from './styles';
import { type TableColumnsType } from 'antd';
import { Table } from 'components/Table';
import { TextS } from 'components/Text';
import { useTheme } from 'styled-components';

export interface IFileRecord {
	key: string;
	label: string;
	value: string;
}

export interface IChargeReviewTableProps {
	data: IFileRecord[];
}

const ChargeReviewTable = ({ data }: IChargeReviewTableProps) => {
	const theme = useTheme();

	const columns: TableColumnsType<IFileRecord> = [
		{
			title: 'Campo',
			dataIndex: 'label',
			render: (value: string) => (
				<TextS style={{ color: theme.textGray }}>{value}</TextS>
			),
		},
		{
			title: 'Valor',
			dataIndex: 'value',
			render: (value: string) => (
				<TextS style={{ color: theme.textGray }}>{value}</TextS>
			),
		},
	];

	return (
		<TableWrapper>
			<Table
				style={{ width: '100%' }}
				columns={columns}
				dataSource={data}
				pagination={false}
				rowKey="key"
			/>
		</TableWrapper>
	);
};

export default ChargeReviewTable;
